export const UserCreatedInputField = () => {
    return null;
};
